import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getTsdNoteListData } from './mockData'
import type { ITsdNote } from '~/types/note/models'

export const {
  getNotes: getTsdNotes,
  postNote: postTsdNote,
  patchNote: patchTsdNote,
  deleteNote: deleteTsdNote,
  handlers,
} = makeNoteAPIs<ITsdNote>({
  apiPathEntityNamePrefix: 'tsd',
  getNoteListDataFn: getTsdNoteListData,
})
